import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

export interface AudioState {
    playing: boolean;
}

const initialState: AudioState = {
    playing: false,
};

export const audioSlice = createSlice({
    name: 'audio',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setPlaying: (state: AudioState, action: PayloadAction<boolean>) => {
            state.playing = action.payload;
        },
    },

});

export const { setPlaying } = audioSlice.actions;

export const selectPlaying = (state: RootState) => state.audio.playing;

export default audioSlice.reducer;
